import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTournament, setTournaments } from "../../redux/actions/tournaments";
import axios from "axios";
import { getSelectedTournament } from "../../screens/home/components/matchGames/components/TournamnetsSelector/utils/tournament";

const TournnamentProvider = ({children})=>{
    const [hasFetchTournaments, setHasFetchTournaments] = useState(false)
    const selectedTournament = useSelector(state => state?.tournaments?.selectedTournament)
    const dispatch = useDispatch();

    useEffect(()=>{
        if(selectedTournament) return
        const urlToFetchTournaments = 'https://web-production-58ed.up.railway.app/api/dt/get/torneos'
        const fetchAllTournament = async ()=>{
            try {
            const allTournaments = await axios.get(urlToFetchTournaments)
            const enablesTournaments = allTournaments?.data?.torneos?.filter(tournament => tournament?.esActivo === true)
            dispatch(setTournaments(enablesTournaments))
            const selectedTournamentIndex = enablesTournaments.length - 1 > 0 ? enablesTournaments.length - 1 : 0
            const lastSelectedTournament = getSelectedTournament();
            const targetTournament = enablesTournaments?.find(tournament => tournament?.torneoObjetivo === true);
     
            dispatch(selectTournament(lastSelectedTournament || targetTournament  || enablesTournaments?.[selectedTournamentIndex]))               
            } catch (error) {
                setHasFetchTournaments(!hasFetchTournaments)
                
            } finally{
                setHasFetchTournaments(!hasFetchTournaments)
            }
        }
        fetchAllTournament();

    },[])

    if(!hasFetchTournaments) return null

    return children

}

export default TournnamentProvider